

import { empty } from "../../../game/characters/empty";
import { globals } from "../../../game/characters/globals";
import * as funcs from "../../components/functions";
import { saveObject } from "../../components/menu/SaveLoad";
import AdvanceSlice, { setAdvance } from '../../store/slices/AdvanceSlice';
import { GameObject, TClickableItemsINT, TimageINT, TuiINT } from "../../store/slices/gameObjectSlice";
import { GameNames } from "../../store/slices/GameTypes";
import { setMenu } from "../../store/slices/menuSlice";
import { RootState, store } from "../../store/store";
import { jump } from "../jump";
import Game from "../Game";
import ImageClass from "../Image";
// import { ActionEvents } from "../../components/Tadvance";
export interface SearchSceneINT {
    scene: GameObject | null,
    promiseData: any,
    additionalScenes?: GameObject[],
    ignoreIndex?: boolean;
    forceSendNode?: boolean;
    firstNode?: Node<unknown> | null;
    potentialNode: null | Node<unknown>[];
}
export class Node<Function> {
    next: Node<Function> | null = null;
    prev: Node<Function> | null | undefined = null;
    promise!: (value: unknown) => void;
    constructor(public func: (forceAction?: boolean) => void, public data: any, public actionId: GameNames) { }
}

export class Action {
    // static nodeMerge: any;
    static id = 0;
    static head: Node<Function> | null = null;
    static tail: Node<Function> | null = null;
    static skipExecute = false;
    static dispatch: any = undefined;
    static advance = true;
    static searchingScene: SearchSceneINT;

    constructor(public readonly data: any, private actionId: GameNames, public promiseData?: any) { }
    run(action: (callback: (options?: { advance: boolean; }) => void) => void, immediateAction = true): Promise<any> {
        const a = this;
        return new Promise((res, rej) => {


            const executeAction = (forceAction?: boolean) => {
                // Game.actionPromise = res;
                if ((!Action.skipExecute && !Action.searchingScene?.scene) || forceAction) {

                    action(() => {

                    });
                }
                if (immediateAction || Action.searchingScene?.scene) {
                    res(this.promiseData || false);
                }
            };
            const node = new Node((forceAction?: boolean) => { executeAction(forceAction); }, this.data, this.actionId);
            node.promise = res;
            if (!Action.head) {
                Action.head = Action.tail = node;
                if (!Game.Action) {

                    Game.Action = Action.head;
                    // Removing the ! will cause a big where you can click twice to advance when rolling back in a scene with input text -> example - start of the game.
                    if (!Game.Action.data.wait && !Game.Action.data.displayUI) {
                        Game.Action?.func();
                    }
                }
            } else {
                // If the type is condition, enter the nodes in between and not last
                node.prev = Action.tail;
                Action.tail!.next = node;
                Action.tail = node;
            }
            if (Action.searchingScene?.scene) {
                const foundNode = findNodeCondition(Action.searchingScene?.scene, node);
                if (foundNode === true) {
                    // do nothing

                } else if (foundNode) {
                    // Game.Action = node;
                    Game.rollback = 0;
                    if (Action.advance) {
                        store.dispatch(setAdvance({ canAdvance: true }));
                    }
                    Action.advance = true;
                    if (Action.dispatch) {
                        store.dispatch(Action.dispatch);
                        Action.dispatch = null;
                    }
                    // if(Game.rollback){

                    // }
                    if (Action.searchingScene.promiseData) {

                        foundNode.promise(Action.searchingScene.promiseData);
                    } else if ((Action.searchingScene.promiseData === undefined && !Action.searchingScene.scene.waitInput) || (!Game.Action?.prev && !Action.searchingScene.scene.waitInput)) {
                        foundNode.promise(false);
                    }
                    return setNode(foundNode);
                } else if (foundNode !== null) {

                    return node.func();
                }
            }



            return node;
        });

    }

    static getNextAction(): Promise<Node<Function> | null | undefined> {

        return new Promise((res) => {
            setTimeout(() => {

                if (Game.Action?.next) {

                    res(Game.Action = Game.Action?.next);
                }
                res(null);
            });
        });


    }



    static async searchScene(data: SearchSceneINT, advance = true): Promise<Node<Function> | null> {
        // Action.nodeMerge = {};

        Action.head = null;
        Game.Action = null;

        const functions = funcs;
        Action.advance = advance;
        Action.searchingScene = { ...Action.searchingScene, ...data };
        // const currentScene = (store.getState() as RootState).gameObject.present.currentScene;
        const currentScene = data.scene?.currentScene;
        // @ts-ignore-start
        await (functions[currentScene])();
        // @ts-ignore-end



        return null;
    }
}

function setNode(node: Node<unknown>): void {
    Game.Action = node;
    if (node.next) {
        let tail = node.next;
        while (tail.next) {
            tail = tail.next;
        }
        Action.tail = tail;

    } else {

        Action.tail = node;
    }
    if (node.actionId === GameNames.CHARACTERS) {
        node.promise(false);
    }
    if (Action.searchingScene.scene) {
        Action.searchingScene.scene = JSON.parse(JSON.stringify({ ...store.getState().gameObject.present, ...Action.searchingScene.scene }));
        // if (Action.searchingScene.scene?.talk) {
        //     Action.searchingScene.scene.talk = { ...Action.searchingScene.scene?.talk, ...node.data };
        // }

        let _image = findClosestImage(node);
        if (!ImageClass._globalImages.get(Action.searchingScene.scene?.image.key)) {
            if (!_image) {
                const imageInScene = Action.searchingScene.additionalScenes?.reverse().find(i => {
                    if (i.lastUpdated === GameNames.IMAGE) {

                        return ImageClass._globalImages.get(i.image.key);
                    }
                    return false;
                });

                if (imageInScene) {
                    _image = imageInScene.image as any;
                }
            }
            if (_image) {
                Action.searchingScene.scene!.image = { ...(_image?.data || _image), ...Action.searchingScene.scene!.image } as TimageINT;
            }
        } else if (_image) {
            Action.searchingScene.scene!.image = { ...(_image?.data || _image), ...Action.searchingScene.scene!.image } as TimageINT;
        }
        if (Action.searchingScene.scene!.talk) {
            Action.searchingScene.scene!.shouldStop = Action.searchingScene.scene!.talk.options?.wait != null ? !!Action.searchingScene.scene!.talk.options?.wait : true;
        }
        if (Action.searchingScene.scene!) {
            Action.searchingScene.scene!.index = getNodeIndex(node);

        }
        if (node.actionId === GameNames.TALK) {
            Action.searchingScene.scene!.talk = node.data;
            Action.searchingScene.scene!.lastUpdated = node.actionId;

        }
        if (node.actionId === GameNames.QUESTION) {
            Action.searchingScene.scene!.question = { ...Action.searchingScene.scene!.question, ...node.data.question };
            Action.searchingScene.scene!.talk = { ...Action.searchingScene.scene!.question.title, ...Action.searchingScene.scene!.talk };
            Action.searchingScene.scene!.waitInput = true;

        }
    }

    const payload: Partial<saveObject> = ({ ...store.getState(), gameObject: { ...store.getState().gameObject, present: Action.searchingScene.scene! } });
    // TODO: check last image for nodes to prevent a case where someone saved before I added a new image ( and then partial image) and the partial would load on different image.
    // go back on the node and place partials inside "partialsToDisplay" under images object, and the main image as the main image.
    //to reproduce - save the game, and then add main image before the save and partial image after the save.
    Action.searchingScene = { scene: null, promiseData: null, potentialNode: null };

    if (node.actionId === GameNames.QUESTION && store.getState().gameObject.present.question.displayQuestion === false) {
    } else {
        store.dispatch({ type: "reset", payload });

    }

    store.dispatch(setMenu({ loading: false }));
    // node?.prev?.func();


}

function findSceneByImageLogic(scene: any, sceneToCompare: any) {

    if (scene?.image.partialsToDisplay?.length) {
        if (sceneToCompare?.partialsToDisplay?.length) {
            return [...scene?.image.partialsToDisplay].pop().key === sceneToCompare.key || [...scene?.image.partialsToDisplay].pop().key === [...sceneToCompare?.partialsToDisplay].pop().key;
        }
        return [...scene?.image.partialsToDisplay].pop().key === sceneToCompare.key;
    }

    if (sceneToCompare.key == scene?.image?.key) {
        return true;
    }
    if (sceneToCompare.key == scene?.animations?.key) {
        return true;
    }
    if (!sceneToCompare.key) {
        if (sceneToCompare?.text && sceneToCompare?.text == scene?.talk?.text && (scene.lastUpdated === sceneToCompare.type)) {
            return true;
        }
    }
    return false;

}
function getLastNodeByID(node: Node<unknown>, type: GameNames): null | Node<unknown> {
    if (!node) {
        return null;
    }
    if (node.actionId === type) {
        return node;
    }
    return getLastNodeByID(node.prev!, type);


}
function getNodeIndex(node: Node<unknown>, counter = 1): number {
    if (!node) {
        return 0;
    }
    if (node.prev) {
        return getNodeIndex(node.prev, ++counter);
    }
    return counter;
}

function findClosestImage(node: Node<unknown> | null | undefined): Node<unknown> | null {
    if (!node) {
        return null;
    }
    if (node.data.url && (node.actionId === GameNames.IMAGE || node.actionId === GameNames.IMAGE_PAR)) {
        return node;
    }
    return findClosestImage(node.prev);



}
// TODO: IDEA - 
// run until the end of the scene, if there isn't two similar texts, return the one you found while setting the index.
// Change potential node to array, and if there is only one, return it. if there is two continue as today.
// can test on page 16 save name: ("test action here ")
function findNodeCondition(scene: any, node: Node<unknown>, counter = 0, _potentialNode: Node<unknown> | null = null, doJump = true): boolean | null | Node<unknown> {
    // TODO: bug to fix- if you split a scenario into two functions and some load it in a missing line that is no longer there, if you click advance and rollback to that line the scene will start from the beginning
    // TODO: #2 bug to fix -> if you have a scenario that includes the same image, and one has wait and hide text on it, the game will always "find" the first one instead of the "real" one.
    //TODO: #3 bug to fix - if the game can't find where to stop and the node is a question, the game will freeze (needs to do node.func() if it didn't find any node and it's a question)
    // How to reproduce - create scenario with one line and questions -> save on the line then delete it.
    // TODO: #4 - in order to find the specific node (even if there are duplicate texts and images) - after finding potential node, keep searching for the previous ones

    if (!Action.searchingScene.firstNode) {
        Action.searchingScene.firstNode = node;
    }

    if (!Action.searchingScene.firstNode?.data.text && node.data.text) {
        Action.searchingScene.firstNode = { ...Action.searchingScene.firstNode, data: { ...Action.searchingScene.firstNode.data, ...node.data } };
    }
    // TODO: change blackscreen to fadeout on real image
    if (!Action.searchingScene.firstNode?.data.key && node.data.key) {
        if ((scene.image.key == "BlackScreen" && node.data.key !== "BlackScreen")) {

        } else {
            Action.searchingScene.firstNode = { ...Action.searchingScene.firstNode, data: { ...Action.searchingScene.firstNode.data, ...node.data } };
        }

    }
    if (Action.searchingScene.forceSendNode) {
        return node;
    }
    let potentialNode = null;
    // Action.nodeMerge = { current: { ...Action.nodeMerge, ...node.data, type: node.actionId }, previousScenes: [...(Action.nodeMerge.previousScenes || []), node] };
    if (scene.lastUpdated !== node.actionId && (node.actionId !== GameNames.JUMP)) { return false; }

    // TODO: change to something generic
    if (node.actionId === GameNames.INSTA && node.actionId === scene.lastUpdated) {
        return node;
    }

    switch (node.actionId) {
        case GameNames.QUESTION:
            if (node.data.question?.title?.key && node.data.question.title.key === scene.question.title.key) {
                // Action.advance = true
                // if (scene.question.displayQuestion) {

                return node;
                // }
            }
            break;
        case GameNames.UI:
            if ((node.data as TuiINT).key && (scene.ui as TuiINT).key != null && (node.data as TuiINT)?.key === (scene.ui as TuiINT).key ||
                (node.data as TClickableItemsINT).key && (scene.clickableMap as TClickableItemsINT).key != null && (node.data as TClickableItemsINT)?.key === (scene.clickableMap as TClickableItemsINT).key
            ) {
                return node;
            }

            break;
        case GameNames.IMAGE:
        case GameNames.IMAGE_PAR:
        case GameNames.ANIMATION:
            if (findSceneByImageLogic(scene, node.data)) {
                const talkNode = getLastNodeByID(node, GameNames.TALK);
                if (!scene.talk.text || !talkNode) {

                    potentialNode = node;
                } else if (Action.searchingScene.potentialNode && scene.talk.text === talkNode?.data.text) {
                    potentialNode = node;
                } else if (!Action.searchingScene.potentialNode || Action.searchingScene.ignoreIndex) {
                    potentialNode = node;
                }
            }

            break;
        case GameNames.INPUT:
            if (node.data.text && node.data.text === scene?.textInput?.text) {

                return node;
            }

            break;
        case GameNames.TALK:
            if (node.data.text && node.data.text === scene?.talk?.text) {
                const imageNode = getLastNodeByID(node, GameNames.IMAGE);
                if (!imageNode) {
                    potentialNode = node;
                } else if (findSceneByImageLogic(scene, imageNode.data)) {
                    potentialNode = node;
                } else if (!Action.searchingScene.potentialNode) {
                    potentialNode = node;
                }
            }

            break;
        case GameNames.JUMP:
            if (doJump === false) {
                return false;
            }
            if (!Action.searchingScene.ignoreIndex && Action.searchingScene.potentialNode?.length === 1) {
                Action.searchingScene.ignoreIndex = true;
                Action.searchScene({ scene, promiseData: Action.searchingScene.promiseData, additionalScenes: Action.searchingScene.additionalScenes, potentialNode: Action.searchingScene.potentialNode }, false);
                return true;
            }
            if (Action.searchingScene.additionalScenes?.length) {
                // if (Action.searchingScene.potentialNode) {
                //     console.log("nodeIndex", getNodeIndex(Action.searchingScene.potentialNode), "sceneIndex", scene.index);
                //     Action.searchScene({ promiseData: Action.searchingScene.promiseData, scene: { ...scene, index: getNodeIndex(Action.searchingScene.potentialNode) }, additionalScenes: Action.searchingScene.additionalScenes, potentialNode: Action.searchingScene.potentialNode }, !store.getState().menu.loading);
                //     return true;
                // }
                const newScene = Action.searchingScene.additionalScenes.pop() as GameObject;
                Action.searchScene({ promiseData: Action.searchingScene.promiseData, scene: newScene, additionalScenes: Action.searchingScene.additionalScenes, potentialNode: Action.searchingScene.potentialNode }, false);
                return true;
            }

            // if (Action.head?.next == null) {
            //     Action.head?.func();
            // }
            // // node.func(true);

            Action.head = null;
            Action.tail = null;
            Game.Action = null;

            const currentScene = (store.getState() as RootState).gameObject.present.currentScene;
            setTimeout(() => {
                if (Action.searchingScene.firstNode) {
                    // const obj = JSON.parse(JSON.stringify(store.getState().gameObject.present));
                    scene = JSON.parse(JSON.stringify(scene));
                    if (Action.searchingScene.firstNode.data.text) {

                        scene.talk = Action.searchingScene.firstNode.data;
                        // scene.talk.options = { hideText: true };
                        scene.talk.hide = true;
                    }
                    if (Action.searchingScene.firstNode.data.url) {
                        if (Action.searchingScene.firstNode.data.type === GameNames.ANIMATION) {
                            // obj.Animations.sources = [Action.searchingScene.firstNode.data];
                            // obj.Animations.key = Action.searchingScene.firstNode.data.key;
                            scene.animations = { ...Action.searchingScene.firstNode.data, sources: [Action.searchingScene.firstNode.data] };

                        } else if (Action.searchingScene.firstNode.data.type === GameNames.IMAGE || Action.searchingScene.firstNode.data.type === GameNames.IMAGE_PAR) {
                            scene.animations = {};
                            scene.image = Action.searchingScene.firstNode.data;
                        }
                    }
                    scene.question.displayQuestion = false;

                    store.dispatch({ type: "reset", payload: { ...store.getState(), gameObject: { ...store.getState().gameObject, present: { ...store.getState().gameObject.present, ...scene } } } });
                }

                // @ts-ignore-start
                jump(funcs[scene.currentScene], scene.currentScene);

                store.dispatch(setMenu({ loading: false }));
                Action.searchingScene = { scene: null, promiseData: null, potentialNode: null };
            });
            return null;

        default:
            return false;
    }

    if (doJump === false) {
        return potentialNode;
    }

    let _nodesFoundedCounter = 0;
    let searchIn = [];
    if (potentialNode) {
        // console.log(Action.searchingScene.potentialNode);
        // console.log(gameObject.past?.slice(-10))
        // (Action.nodeMerge.previousScenes as Node<unknown>[]).filter(node => {
        // if (Action.searchingScene.additionalScenes) {
        //     const dupes = [...Action.searchingScene.additionalScenes];
        //     const firstJumpIndex = dupes.reverse().findIndex(a => a.lastUpdated == GameNames.JUMP);
        //     searchIn = dupes.slice(0, firstJumpIndex).reverse();
        //     for (let i = searchIn.length - 1; i > 0; i--) {
        //         const pastScene = searchIn[i];
        //         if (potentialNode.prev == null && pastScene.lastUpdated !== GameNames.JUMP) {
        //             return false;
        //         }
        //         const res = findNodeCondition(pastScene, potentialNode.prev!, counter++, _potentialNode || potentialNode, false);
        //         if (res) {
        //             _nodesFoundedCounter++;
        //         }
        //     }

        // }
        // });
        // if (_nodesFoundedCounter <= Math.floor((searchIn.length || 1) / 2)) {
        //     return false;
        // }
        // console.log(_nodesFoundedCounter);
        if (!Action.searchingScene.potentialNode) {
            Action.searchingScene.potentialNode = [];
        }
        if (potentialNode) {

            Action.searchingScene.potentialNode.push(potentialNode);
        }

        if (scene.index != null) {
            if (Action.searchingScene.ignoreIndex || getNodeIndex(node) === scene.index) {
                // a test condition -> if the only potential node is an image without a text, return the next one.
                // put this in comment, it fucks up things like the "bothbj" at toilet, if you scroll back once and click it doesn't trigger
                // if ((node.actionId === GameNames.IMAGE || node.actionId === GameNames.IMAGE_PAR) && node.data?.options?.wait !== true) {
                //     Action.searchingScene.forceSendNode = true;
                //     return false;
                // }

                return node;
            } else {
                return false;
            }
        }
        return node;

    }
    else if (Action.searchingScene.potentialNode && scene.version === Game.version && Action.searchingScene.potentialNode && getNodeIndex(Action.searchingScene.potentialNode[Action.searchingScene.potentialNode.length - 1]) === getNodeIndex(node)) {
        return node;
    }
    // else if (Action.searchingScene.ignoreIndex && Action.searchingScene.potentialNode?.length === 1 && Action.searchingScene.potentialNode?.[0]) {
    //     // return Action.searchingScene.potentialNode[0];

    // }
    else {

        return false;
    }





}

